import { Alert, Button, type SxProps, type Theme } from "@mui/material";
import { type SignatureConfirmationState } from "hooks/submission/useSignatureConfirmation";

export function SignatureConfirmationAlert({
  signingCompleted,
  signingFlowConfirmed,
  confirmationState,
  isAwaitingPostSignatureTransition,
  onRetry,
  sx,
}: {
  signingCompleted: boolean;
  signingFlowConfirmed: boolean;
  confirmationState: SignatureConfirmationState;
  isAwaitingPostSignatureTransition: boolean;
  onRetry: () => void;
  sx?: SxProps<Theme>;
}) {
  if (signingFlowConfirmed) {
    return (
      <Alert severity="success" sx={sx}>
        Your signature has been recorded. No further action is needed.
      </Alert>
    );
  }

  if (confirmationState === "pending" && !signingCompleted) {
    return (
      <Alert severity="info" sx={sx}>
        Your signature was submitted. We’re confirming it with Encamp now.
      </Alert>
    );
  }

  if (confirmationState === "pending" && isAwaitingPostSignatureTransition) {
    return (
      <Alert severity="info" sx={sx}>
        Your signature has been recorded. We’re moving the submission forward now.
      </Alert>
    );
  }

  if (confirmationState === "delayed") {
    return (
      <Alert
        severity="warning"
        sx={sx}
        action={
          <Button color="inherit" size="small" onClick={onRetry}>
            Check again
          </Button>
        }
      >
        {signingCompleted
          ? "Your signature was recorded, but the submission hasn’t moved forward yet. If this persists, contact Encamp Support."
          : "Your signature was submitted, but Encamp hasn’t confirmed it yet. If this persists, contact Encamp Support."}
      </Alert>
    );
  }

  return null;
}
